import React from 'react';
import { styled } from '@linaria/react';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { Price } from '@daedalus/atlas/Price';
import { Text } from '@daedalus/atlas/Text';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { CurrencyDisplayVariant } from '@daedalus/core/src/price/business/formatPrice';
import { NUMBER_OF_DECIMALS_FOR_PRICE } from '.';
import { TotalPriceSkeleton, TotalPriceTitleSkeleton } from './Skeleton';
interface PriceTotalProps {
  currencyCode: string;
  totalPrice: number;
  onCurrencyClick?: () => void;
  nights: number;
  rooms: number;
  guests: number;
  isPostBooking?: boolean;
  isPriceLoading?: boolean;
  showCurrencySelector?: boolean;
  displayNumberOfRooms?: boolean;
  currencyDisplayVariant?: CurrencyDisplayVariant;
  taxAndFeesMessage?: React.ReactNode;
}
const _exp = /*#__PURE__*/() => Price;
const StyledPrice = /*#__PURE__*/styled(_exp())({
  name: "StyledPrice",
  class: "s8r6e4l",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => Text;
const TaxTextWrapper = /*#__PURE__*/styled(_exp2())({
  name: "TaxTextWrapper",
  class: "tt6tbso",
  propsAsIs: true
});
const _exp3 = /*#__PURE__*/() => ButtonLink;
const ButtonLinkWrapper = /*#__PURE__*/styled(_exp3())({
  name: "ButtonLinkWrapper",
  class: "bd5pgwi",
  propsAsIs: true
});
const PriceTotal = ({
  currencyCode,
  totalPrice,
  onCurrencyClick,
  nights,
  rooms,
  guests,
  isPriceLoading = false,
  showCurrencySelector = true,
  displayNumberOfRooms = true,
  currencyDisplayVariant
}: PriceTotalProps) => {
  return <Grid container justify="space-between" wrap="nowrap" spacing="s000" direction="column">
      <Grid mobileSm="fit" container spacing="s000" justify="space-between" alignItems="center">
        {isPriceLoading ? <TotalPriceTitleSkeleton /> : <Text variant="titleM">
            <FormattedMessageWrapper id="payment.total" defaultMessage="Total" />
            {showCurrencySelector && <>
                {' '}
                (
                <ButtonLinkWrapper onClick={onCurrencyClick} size="lg" isCompact variant="info">
                  {currencyCode?.toLocaleUpperCase()}
                </ButtonLinkWrapper>
                )
              </>}
          </Text>}
        {isPriceLoading ? <TotalPriceSkeleton /> : <StyledPrice maximumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE} minimumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE} value={totalPrice} currency={currencyCode} size="lg" currencyDisplayVariant={currencyDisplayVariant} />}
      </Grid>
      <Grid container spacing="s000" alignItems="flex-start" justify="space-between" gap="s500">
        <Text variant="bodyS" colorPath="content.neutral.c600">
          {displayNumberOfRooms ? <FormattedMessageWrapper id="roomsAndNightsAndGuests" defaultMessage="{nights, plural, one {1 night} other {# nights}}, {rooms, plural, one {1 room} other {# rooms}}, {guests, plural, one {1 guest} other {# guests}}" values={{
          nights,
          rooms,
          guests
        }} /> : <FormattedMessageWrapper id="nightsAndGuests" defaultMessage="{nights, plural, one {1 night} other {# nights}}, {guests, plural, one {1 guest} other {# guests}}" values={{
          nights,
          guests
        }} />}
        </Text>
        <TaxTextWrapper variant="bodyS" colorPath="content.neutral.c600" align="right">
          <FormattedMessageWrapper id="includingTaxesShort" defaultMessage="incl tax & fees" />
        </TaxTextWrapper>
      </Grid>
    </Grid>;
};
export default PriceTotal;

require("./PriceTotal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceTotal.tsx");